export class MultipleChoiceOption {
    constructor(id, text, isCorrect, explanation) {
        this.isChecked = false;
        this.id = id;
        this.text = text;
        this.isCorrect = isCorrect;
        this.explanation = explanation;
    }
}
